// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".conversation-name[data-v-0ba3ede8]{width:100%;font-size:16px;line-height:34px}\n", ""]);
// Exports
module.exports = exports;
